import {
    BetSlipError,
    BonusBetSlipError,
    SelectionError,
} from '@superbet-group/betting.lib.validation';
import { BetSlipPurchaseType } from '@superbet-group/web.types';
import { ActionContext } from 'vuex';

import { IState } from '@app/store';
import ISelection from '@core/models/betSlip/ISelection';
import { Payout } from '@core/models/betSlip/Payout';
import SelectionChange from '@core/models/betSlip/SelectionChange';
import IBetSlipError, { IBonusBetSlipError } from '@core/models/betSlip/validation/IBetSlipError';
import OfferEvent from '@core/models/offer/OfferEvent';
import { BetSlipType } from '@core/models/shared/betSlip/betSlipEnums';
import { BetSlipGetters } from '@store/modules/ui/betSlip/getters';
import { RelativeRootGetters } from '@store/types';

export type AllBetSlipErrors = {
    sportValidation: BetSlipError[];
    bonusValidation: BonusBetSlipError[] | null;
};
export type BetSlipState = {
    selections: ISelection[];
    stake: number | null;
    type: BetSlipType;
    selectedSystems: number[];
    betSlipErrors: AllBetSlipErrors;
    autoUpdateChanges: boolean;
    changes: Record<OfferEvent['id'], SelectionChange>;
    errors: IBetSlipError[];
    selectionErrors: Record<string, SelectionError>;
    selectionAddError: IBetSlipError | null;
    purchaseType: BetSlipPurchaseType;
    payoutLocked: boolean;
    payout: Payout;
    warning: IBetSlipError | null;
    bonusError: IBonusBetSlipError | null;
    bonusWarning: IBetSlipError | null;
    isBonusSelected: boolean;
    isRecreatingTicket: boolean;
    isSubmittingOdd: Record<string, boolean>;
};

export enum SelectionAddResult {
    added,
    updated,
    removed,
    // Selection is added but there already was a selection for the same event from before
    addedAnother,
}

export interface BetSlipContext extends ActionContext<BetSlipState, IState> {
    getters: BetSlipGetters;
    rootGetters: RelativeRootGetters;
}

export interface MatchSubscription {
    unsubscribe: () => void;
}

export enum BetSlipSelectionAddMode {
    Append = 'append',
}
